import { render, staticRenderFns } from "./UserActions.vue?vue&type=template&id=1304865e&scoped=true&"
import script from "./UserActions.vue?vue&type=script&lang=js&"
export * from "./UserActions.vue?vue&type=script&lang=js&"
import style0 from "./UserActions.vue?vue&type=style&index=0&id=1304865e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1304865e",
  null
  
)

export default component.exports